import { CreateTemplateRequest } from '@/types/api/request/createTemplateTypes';
import { TemplateStatus } from '@/types/enums/enums';

export default { mailText: '', smsText: '', name: '', templateStatus: TemplateStatus.DRAFT } as CreateTemplateRequest;
